import { Grid, Card, CardContent, Typography } from '@mui/material';
import { formatDate } from "../utils"
import { ProjectGridProps } from "../types";

function ProjectGrid(props: ProjectGridProps) {
  const filteredProjects = props.data.filter((project) => project.field === props.type);

  return (
  <Grid container spacing={2} alignItems="stretch">
      {filteredProjects.map((project) => (
        <Grid item xs={12} sm={4} key={project.id}>
          <Card
            className="projectCard"
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
            }}
            onClick={() => project.link && window.open(project.link, '_blank')}
          >
            <CardContent 
              style={{
                flex: '1',
                minHeight: '180px',
                overflow: 'hidden',
              }}
            >
              <Typography variant="h5" color="text.secondary">
                {project.projectName}
              </Typography>
              <Typography component="div">
                {project.description}
              </Typography>
              <Typography variant="body2">{formatDate(new Date(project.endDate as unknown as string))}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default ProjectGrid;
